<tc-setup-grid
    #setupGrid
    [readOnly]="false"
    [colDefConfig]="colDefConfig"
    [setupGridComp]="this"
    [dataSource]="this"
    [actionColumnWidth]="150"
    [actions]="gridActions">
</tc-setup-grid>
